// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const VersionOut = zod.object({
  "commit": zod.union([zod.string(),zod.null()]),
  "deployed_at": zod.union([zod.string(),zod.null()]),
  "version": zod.string()
});

export type VersionOut = zod.input<typeof VersionOut>;
export type VersionOutOutput = zod.output<typeof VersionOut>;
